import { FC } from '../constants/functionCodes';

/** First screen a user can open, in sidebar order. */
export const APP_NAV_ROUTES = [
  { path: '/dashboard', functionCode: FC.HOME },
  { path: '/treasury-payment', functionCode: FC.PAYMENT_INTELLIGENCE },
  { path: '/cash-recon', functionCode: FC.CASH_RECONCILIATION },
  { path: '/credit-card', functionCode: FC.MERCHANT_DATA_HUB },
  { path: '/workforce-operations', functionCode: FC.WORKFORCE_OPTIMIZATION },
  { path: '/hotel-sync/pms-gl-mapping', functionCode: FC.PMS_RECONCILIATION },
  { path: '/workflows/document-validation', functionCode: FC.DOCUMENT_VALIDATION },
  { path: '/workflows/etvl', functionCode: FC.ETVL_ENGINE },
  { path: '/gl-sync', functionCode: FC.GL_SYNC },
  { path: '/tenant-workflow', functionCode: FC.TENANT_WORKFLOW },
  { path: '/user', functionCode: FC.USERS },
  { path: '/master-data', functionCode: FC.MASTER_DATA },
  { path: '/configuration/property', functionCode: FC.PROPERTY },
  { path: '/configuration/property-group', functionCode: FC.PROPERTY_GROUP },
  { path: '/configuration/vendor-master', functionCode: FC.VENDOR_MASTER },
  { path: '/configuration/gl-account-master', functionCode: FC.GL_ACCOUNT_MASTER },
  { path: '/configuration/bank-master', functionCode: FC.BANK_MASTER },
  { path: '/configuration/budget-codes', functionCode: FC.BUDGET_REVENUE_CODES },
  { path: '/configuration/contract-master', functionCode: FC.CONTRACT_MASTER },
  { path: '/app-config', functionCode: FC.APP_CONFIG },
  { path: '/configuration/notification-rules', functionCode: FC.NOTIFICATION_CONFIGURATION },
  { path: '/reference-templates', functionCode: FC.REFERENCE_TEMPLATES },
  { path: '/configuration/department-master', functionCode: FC.DEPARTMENT_MASTER },
  { path: '/configuration/global-employee', functionCode: FC.GLOBAL_EMPLOYEE },
  { path: '/user-logs', functionCode: FC.AUDIT_LOGS },
];

export const NO_ACCESS_PATH = '/no-access';

export function resolveDefaultAppPath(canAccessMenu, isHarmonateUser = false) {
  if (isHarmonateUser) return '/dashboard';
  const match = APP_NAV_ROUTES.find((route) => canAccessMenu(route.functionCode));
  return match ? match.path : NO_ACCESS_PATH;
}
